import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const inlineImage = css`
  margin-inline-start: ${spacing(0.25)};
`
